import { actions } from './lib'

export default store =>
  function logout(state, replace, callback) {
    const queryString = (global.location || {}).search || ''
    const loginPath = `/login${queryString}`

    store
      .dispatch(actions.authLogout())
      .then(() => {
        replace(loginPath)
        callback()
      })
      .catch(err => {
        console.error('/logout onEnter >> err: %o', err)
        replace(loginPath)
        callback()
      })
  }



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/logout.js